import { IGroupedComboBoxItem } from 'grouped-combobox-core';

export function findFontByKey(
    fontKey: string,
    items: IGroupedComboBoxItem[]
): IGroupedComboBoxItem | undefined {
    if (items.length < 2) {
        return items.find((item) => item.itemKey === fontKey);
    } else {
        let left = 0;
        let right = items.length;
        while (right > left) {
            const middle = Math.floor((left + right) / 2);
            const compare = fontKey.localeCompare(items[middle].itemKey);
            if (compare < 0) {
                right = middle;
            } else if (compare > 0) {
                left = middle + 1;
            } else {
                return items[middle];
            }
        }

        return undefined;
    }
}
